import { render, staticRenderFns } from "./FormPolicies.vue?vue&type=template&id=de96d632&scoped=true&"
import script from "./FormPolicies.vue?vue&type=script&lang=js&"
export * from "./FormPolicies.vue?vue&type=script&lang=js&"
import style0 from "./FormPolicies.vue?vue&type=style&index=0&id=de96d632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de96d632",
  null
  
)

export default component.exports